import { Component, EventEmitter, Input, Output,
    ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'tag-button',
    templateUrl: './tag-button.component.html',
    styleUrls: ['./tag-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagButtonComponent {

  @Input()
  value = "";
  @Input()
  icon = "";
  @Input()
  severity:
        | 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined = "info";
  @Input()
  toolTip: string = null;
  @Input()
  active = true;
  @Input()
  clickable = false;
  @Output()
  onClick = new EventEmitter<any>();

  click(): void {
      if (this.clickable) {
          this.onClick.emit(null);
      }
  }
}
